import React, { useState, useEffect } from 'react';
import ProjectPaymentsView from '../views/ProjectPaymentsView';
import Notifier from '../../../components/Notifier';
import Utils from '../../../utils/Utils';
import ProjectController from '../../../controllers/ProjectController';

const ProjectPaymentsState = ({project}) => {
  const [users, setUsers]= useState();
  const [payments, setPayments] = useState();
  const [isLoading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [totalElements, setTotalElements] = useState(0);
  const [sorting, setSorting] = useState([
    {
      columnName: 'id',
      direction: 'desc',
    },
  ]);
  const [pagination, setPagination] = useState({
    page: 0,
    size: 25,
  });

  const getPayments = async (params) => {
    setLoading(true);
   try {
     await ProjectController.getPayments(project.id, params).then(res => {
        setPayments(res.content);
        setTotalElements(res.totalElements);
        setLoading(false);
      }).catch(e => {
       Notifier.error(e.message);
     })
   } catch (e) {
     Notifier.error(e.message);
     setLoading(false);
   } finally {
     setLoading(false);
   }
  }

  const createPayment = async (data) => {
    try {
      await ProjectController.createPayment(project.id, data).then(r => {
        Notifier.success("Payment created successfully!!");
        getPayments();
      });
    } catch (e) {
      Notifier.error(e.message);
    }
  }

  const handleFilterChange = (field, value) => {
    setLoading(true);
    if (Utils.isNull(value) || value === '') {
      setFilters((prev) => {
        const obj = { ...prev };
        delete obj[field];
        return obj;
      });
    } else {
      setFilters((prev) => ({ ...prev, [field]: String(value).trim() }));
    }
    setPagination({ ...pagination, page: 0 });
  };

  const handleClearFilters = () => {
    setFilters({});
  };

  const handleSorting = (sorting) => {
    setLoading(true);
    setSorting(sorting);
  };

  const handlePageChange = (page) => {
    setLoading(true);
    setPagination({ ...pagination, page: page });
  };

  const handlePageSizeChange = (size) => {
    setLoading(true);
    setPagination({ ...pagination, size: size });
  };

 useEffect(() => {
   const getProjectMembers = () => {
     try {
       ProjectController.getMemberSingle(project.id)
       .then((res) => {
         setUsers(
           res.map(u => ({
             label: u?.sid ?? '',
             value: u?.id ?? null
           })))
       })
     } catch (e) {
       Notifier.error(e.message);
     }
   }
   getProjectMembers();
 }, [project.id])

  useEffect(() => {
    let params = {};
    if (!Utils.isNull(pagination)) {
      params['page'] = pagination.page;
      params['size'] = pagination.size;
    }
    if (!Utils.isEmpty(sorting)) {
      params['sort'] = sorting[0].columnName + ',' + sorting[0].direction;
    }
    if (!Utils.isEmpty(filters)) {
        params = { ...params, ...filters };
    }

    getPayments(params);
  }, [filters, sorting, pagination])



  return (
    <ProjectPaymentsView
      users={users}
      projectId={project.id}
      createPayment={createPayment}
      isLoading={isLoading}
      payments={payments}
      totalElements={totalElements}
      sorting={sorting}
      pagination={pagination}
      filters={filters}
      handleFilterChange={handleFilterChange}
      handleClearFilters={handleClearFilters}
      handleSorting={handleSorting}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
    />
  );
};

export default ProjectPaymentsState;
